import { FirstNameTag, GreetingTag, MainAudioTag } from 'consts/data';
import { cloneDeep, isPlainObject, uniqueId } from 'lodash';

class MediaModel {
  static initialFilters = {
    offset: 0,
    limit: 10,
    mediaType: '',
    fileExtension: null,
    name: '',
    mediaGroupName: '',
    includedSystemType: false,
    includedMediaGroup: true,
    text: '',
    excludeManualType: false,
  };

  /**
   *
   * @param {{
   * useConfigAudio: boolean,
   * enableMediaGroup: boolean,
   * media: {},
   * mediaGroupId: {label: string, value: string},
   * mainAudioId: {label: string, value: string},
   * tagsString: [{ id: 'tag-1', content: MainAudioTag, isFixed: true }],
   * }} initialValues
   * @returns {{
   *  enableMediaGroup: false,
   *  mainAudioId: {},
   *  media: {},
   *  mediaGroupId: {},
   * tagsString: [],
   * useConfigAudio: false,
   * }}
   */
  static initialMediaWithConfig(
    initialValues,
    { requiredGreetingTag = false, requiredFirstNameTag = false } = {}
  ) {
    return {
      useConfigAudio: initialValues?.useConfigAudio ?? false,
      enableMediaGroup: initialValues?.enableMediaGroup ?? false,
      mediaGroupId: initialValues?.mediaGroupId ?? '',
      mainAudioId: initialValues?.mainAudioId ?? '',
      media: initialValues?.media ?? '',
      tagsString:
        initialValues?.tagsString ??
        [
          requiredGreetingTag && { id: `tag-${uniqueId()}`, content: GreetingTag, isFixed: true },
          requiredFirstNameTag && { id: `tag-${uniqueId()}`, content: FirstNameTag, isFixed: true },
          { id: `tag-${uniqueId()}`, content: MainAudioTag, isFixed: true },
        ].filter((el) => !!el),
    };
  }

  /**
   *
   * @param {*} mediaWithConfigs
   * @returns {{
   *  enableMediaGroup: false,
   *  mainAudioId: {},
   *  media: {},
   *  mediaGroupId: {},
   * tagsString: [],
   * useConfigAudio: false,
   * audioBuilderSetting: {
   *  tagsString: [],
   *  media: {},
   *  mediaGroup: {}
   * }
   * }}
   */
  static parseBodyRequestForMediaWithConfigs(mediaWithConfigs) {
    if (isPlainObject(mediaWithConfigs)) {
      const tempResult = cloneDeep(mediaWithConfigs);
      const { useConfigAudio, enableMediaGroup } = mediaWithConfigs;

      tempResult.tagsString = (mediaWithConfigs?.tagsString || []).map((el) => el.content).join('');

      //* If config audio
      if (useConfigAudio) {
        tempResult.media = undefined;

        //* If select media group
        if (enableMediaGroup) {
          tempResult.mainAudioId = undefined;
        } else {
          tempResult.mediaGroupId = undefined;
        }
      } else {
        tempResult.mediaGroupId = undefined;
        tempResult.mainAudioId = undefined;
      }

      if (useConfigAudio) {
        //* Build an audioBuilderSetting for request
        const audioBuilderSetting = {
          tagsString: tempResult.tagsString,
        };

        audioBuilderSetting[tempResult.mainAudioId ? 'media' : 'mediaGroup'] = {
          id: tempResult?.mainAudioId?.value ?? tempResult?.mediaGroupId?.value,
        };

        tempResult.audioBuilderSetting = audioBuilderSetting;
      } else {
        tempResult.audioBuilderSetting = null;
      }

      return tempResult;
    }

    return {};
  }
}

export default MediaModel;
